import React, { Component } from 'react';
import PropTypes from 'prop-types';
import onClickOutside from 'react-onclickoutside';

import styles from './Popover.scss';

class Popover extends Component {
    constructor(props) {
        super(props);
        this.toggleVisibility = this.toggleVisibility.bind(this);
        this.handleClickOutside = this.handleClickOutside.bind(this);

        this.state = {
            open: false,
        };
    }

    toggleVisibility() {
        this.setState({ open: !this.state.open });
    }

    handleClickOutside() {
        this.setState({ open: false });
    }

    renderItems() {
        const childrenWithCallback = React.Children.map(this.props.children,
            child => {
                if (child) {
                    return React.cloneElement(child, {
                        selectCallback: this.toggleVisibility,
                    });
                }
            }
        );

        let className = 'content--pinLeft';

        if (this.props.openDirection === 'right') {
            className = 'content--pinRight';
        }

        return (
            <div id="popover-item-container" className={styles[className]} onClick={this.toggleVisibility} data-cy="Popover">
                {childrenWithCallback}
            </div>
        );
    }

    render() {
        return (
            <div id="popover-parent" className={styles.base} data-cy="Popover-render">
                <div className={styles.target} onClick={this.toggleVisibility} data-cy="Popover-onClick">
                    {this.props.target}
                </div>
                {this.state.open && this.renderItems()}
            </div>
        );
    }
}

Popover.propTypes = {
    target: PropTypes.object.isRequired
};

export default onClickOutside(Popover);
